import ConfirmChanges from '@ui-library/modal/confirmChanges';
import useModalView from '@hooks/useModalView';
import React, { useEffect, useState } from 'react';
import { Prompt } from 'react-router-dom';

interface Props {
  active: boolean;
  navigate: (path: string) => void;
  shouldBlockNavigation: (pathname: string) => boolean;
}
interface Location {
  pathname: string;
  search: string;
}
const LEAVE_TEXT =
  'You’re about to leave this page with unsaved changes. Are you sure you want to continue?';
const RouteLeavingGuard = ({ active, navigate, shouldBlockNavigation }: Props) => {
  const [nextLocation, setNextLocation] = useState<Location | null>(null);
  const [confirmedNavigation, setConfirmedNavigation] = useState(false);

  const handleBlockedNavigation = (location: Location): boolean => {
    if (!confirmedNavigation && shouldBlockNavigation(location.pathname)) {
      showCancelModal(true);
      setNextLocation(location);
      return false;
    }
    return true;
  };
  useEffect(() => {
    window.onbeforeunload = active ? () => true : null;
    return () => {
      window.onbeforeunload = null;
    };
  }, [active]);

  const handleConfirmNavigationClick = () => {
    showCancelModal(false);
    setConfirmedNavigation(true);
  };
  const [cancelModal, showCancelModal] = useModalView(
    <ConfirmChanges
      onConfirm={handleConfirmNavigationClick}
      onCancel={() => showCancelModal(false)}
      type="cancel"
      text={LEAVE_TEXT}
    />,
  );
  useEffect(() => {
    if (confirmedNavigation && nextLocation) {
      navigate(nextLocation.pathname + nextLocation.search);
    }
  }, [confirmedNavigation, nextLocation]);
  return (
    <>
      <Prompt when={active} message={handleBlockedNavigation} />
      {cancelModal}
    </>
  );
};
export default RouteLeavingGuard;
